(function ($, root, undefined) { $(function () {
//start

// Use Magnific Popup as the default gallery viewer
$(document).ready(function() {
  $('.gallery').magnificPopup({
				delegate: 'a', // child items selector, by clicking on it popup will open
				type: 'image',
				gallery:{enabled:true}
		});
});

//Slick Slider settings
$(document).ready(function(){
  $('.carousel').slick({
		dots: false,
	  infinite: true,
	  speed: 300,
	  slidesToShow: 1,
	  centerMode: true,
	  variableWidth: true,
		focusOnSelect: false
	});
});

$(document).ready(function(){
  $('.carousell').slick({
	dots: false,
	  infinite: true,
	  speed: 300,
	  slidesToShow: 2,
	  centerMode: true,
	  variableWidth: true,
	focusOnSelect: false
	});
});

//ACF Google Maps (Print map)
function new_map( $el ) {

	// var
	var $markers = $el.find('.marker');

	// vars
	var args = {
		zoom		: 16,
		center		: new google.maps.LatLng(0, 0),
		mapTypeId	: google.maps.MapTypeId.ROADMAP
	};

	// create map
	var map = new google.maps.Map( $el[0], args);


	// add a markers reference
	map.markers = [];

	// add markers
	$markers.each(function(){

    	add_marker( $(this), map );

	});

	// center map
	center_map( map );

	// return
	return map;
}

//ACF Google Maps (Add marker)
function add_marker( $marker, map ) {

	// var
	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

	// create marker
	var marker = new google.maps.Marker({
		position	: latlng,
		map			: map
	});

	// add to array
	map.markers.push( marker );

	// if marker contains HTML, add it to an infoWindow
	if( $marker.html() )
	{
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content		: $marker.html()
		});

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function() {
			infowindow.open( map, marker );
		});
	}
}

//ACF Google Maps (Center map)
function center_map( map ) {
	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){
		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
		bounds.extend( latlng );
	});

	// only 1 marker?
	if( map.markers.length == 1 )
	{
		// set center of map
	    map.setCenter( bounds.getCenter() );
	    map.setZoom( 16 );
	}
	else
	{
		// fit to bounds
		map.fitBounds( bounds );
	}
}

//ACF Google Maps (Render map on document ready)
var map = null;

$(document).ready(function(){
	$('.location-map').each(function(){
		// create map
		map = new_map( $(this) );
	});
});


//jQuery datepicker settings (Date range)
var dateFormat = "mm/dd/yy",
from = $( "#from" ).datepicker({
	changeMonth: false,
	changeYear: false,
	prevText: '&#xf104;',
	nextText: '&#xf105;',
    beforeShowDay: nonWorkingDates,
	numberOfMonths: 1,
	dateFormat: 'dd-mm-yy',
	minDate: 0,
	onSelect: function( selectedDate ) {
		$( "#to" ).datepicker( "option", "minDate", selectedDate );
	}
})

to = $( "#to" ).datepicker({
	changeMonth: false,
	changeYear: false,
	prevText: '&#xf104;',
	nextText: '&#xf105;',
    beforeShowDay: nonWorkingDates,
	numberOfMonths: 1,
	dateFormat: 'dd-mm-yy',
    minDate: 0,
	onSelect: function( selectedDate ) {
		$( "#from" ).datepicker( "option", "maxDate", selectedDate );
	}
})


//Remove :focus outline unless user is using the keyboard to navigate
function handleFirstTab(e) {
	if (e.keyCode === 9) {
		document.body.classList.add('user-is-tabbing');
		window.removeEventListener('keydown', handleFirstTab);
		window.addEventListener('mousedown', handleMouseDownOnce);
	}
}
function handleMouseDownOnce() {
	document.body.classList.remove('user-is-tabbing');
	window.removeEventListener('mousedown', handleMouseDownOnce);
	window.addEventListener('keydown', handleFirstTab);
}
window.addEventListener('keydown', handleFirstTab);


//Custom SVG WPCF7 gif loader
$(document).ready(function() {
  $(".ajax-loader").html('<div class="loader" title="7"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve"><rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2"><animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s" repeatCount="indefinite" /><animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s" repeatCount="indefinite" /><animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite" /></rect><rect x="8" y="10" width="4" height="10" fill="#333"  opacity="0.2"><animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s" repeatCount="indefinite" /><animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" /><animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" /></rect><rect x="16" y="10" width="4" height="10" fill="#333"  opacity="0.2"><animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s" repeatCount="indefinite" /><animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" /><animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" /></rect></svg></div>');
});

//Smooth scroll
$('a[href*="#"]:not([href="#"])').click(function() {
  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 500);
      return false;
    }
  }
});

//END
}); })(jQuery, this);
